// This FF whitelists Apdex, Browser Metrics and performance related analytics and blocks everything else
export const FILTER_EVENTS_FF = 'confluence.frontend.filter-events';

// This FF holds additional global matchers that should be used for whitelisting
// any additional events beyond the already allowed Apdex/BM performance events
export const FILTER_EVENTS_EXEMPTIONS_FF = 'confluence.frontend.filter-events.exemptions';
